import React from 'react';
import { FRANJAS } from '../../utils/franjas';

// Grilla para que el admin marque en qué días/franjas puede el cliente
// (hablado antes por teléfono) — todo arranca "tachado" (sin marcar) y el
// admin toca las combinaciones que sí sirven. El técnico asignado va a ver
// solo esas opciones al confirmar el horario definitivo (ConfirmarHorarioSheet).
//
// value: array de { dia, franja } — ej. [{ dia: 'MIERCOLES', franja: '10:00-12:00' }]
// onChange: (nuevoValue) => void

export const DIAS_SEMANA = [
    { id: 'LUNES',     corto: 'Lun' },
    { id: 'MARTES',    corto: 'Mar' },
    { id: 'MIERCOLES', corto: 'Mié' },
    { id: 'JUEVES',    corto: 'Jue' },
    { id: 'VIERNES',   corto: 'Vie' },
    { id: 'SABADO',    corto: 'Sáb' },
];

// Las 4 franjas de 2 h de 8 a 16, las mismas de toda la app (20-oct-2026)
export { FRANJAS };

export default function SelectorVentanas({ value, onChange, ayuda = null, opcional = false }) {
    const ventanas = value || [];

    const estaMarcada = (dia, franja) =>
        ventanas.some(v => v.dia === dia && v.franja === franja);

    const toggle = (dia, franja) => {
        if (estaMarcada(dia, franja)) {
            onChange(ventanas.filter(v => !(v.dia === dia && v.franja === franja)));
        } else {
            onChange([...ventanas, { dia, franja }]);
        }
    };

    return (
        <div>
            <p className="text-caption text-muted mb-2">
                {ayuda || 'Tocá las combinaciones que le sirven al cliente — el resto queda descartado. El técnico va a poder elegir el día y horario exacto solo dentro de lo que marques acá.'}
            </p>
            <div className="overflow-x-auto -mx-1 px-1">
                <table className="w-full border-separate" style={{ borderSpacing: '4px' }}>
                    <thead>
                        <tr>
                            <th className="w-16" />
                            {DIAS_SEMANA.map(d => (
                                <th key={d.id} className="text-label font-black text-muted uppercase pb-1">
                                    {d.corto}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {FRANJAS.map(f => (
                            <tr key={f.id}>
                                <td className="text-label font-bold text-muted pr-1 whitespace-nowrap">
                                    {f.corto}
                                </td>
                                {DIAS_SEMANA.map(d => {
                                    const marcada = estaMarcada(d.id, f.id);
                                    return (
                                        <td key={d.id}>
                                            <button
                                                type="button"
                                                onClick={() => toggle(d.id, f.id)}
                                                title={`${d.corto} · ${f.rango}hs`}
                                                className={`w-full h-9 rounded-lg text-label font-black transition-all active:scale-95 ${
                                                    marcada
                                                        ? 'bg-brand-red text-white'
                                                        : 'bg-chip text-muted/40 line-through'
                                                }`}
                                            >
                                                {marcada ? '✓' : '—'}
                                            </button>
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {ventanas.length === 0 && !opcional && (
                <p className="text-label font-bold text-brand-red mt-2">
                    ⚠ Marcá al menos una combinación de día y horario
                </p>
            )}
        </div>
    );
}
